<!--
 * @Desc: 问题单左侧目录指南组件
 * @Author: hedahai
 * @Date: 2020-10-16 14:21:33
-->
<template>
  <div class="quest-directory">
    <!-- 头部圆圈 -->
    <div class="cell">
      <div class="title"></div>
      <div class="circle-view">
        <div class="line"
             style="visibility:hidden"></div>
        <div class="header-footer-circle"></div>
        <div class="line"></div>
      </div>
    </div>
    <!-- 中间部分 -->
    <div class="cell"
         v-for="(item, index) in list"
         :key="index"
         @click="cellDidClick(index)">
      <div v-if="index === selIndex"
           class="title highligt-title">{{item.title}}</div>
      <div v-else
           class="title gray-title">{{item.title}}</div>
      <div class="circle-view">
        <div class="line"></div>
        <div v-if="item.section === true && index === selIndex"
             class="big-circle circle highligt"></div>
        <div v-else-if="item.section === true && index !== selIndex"
             class="big-circle circle gray"></div>
        <div v-else-if="item.section !== true && index === selIndex"
             class="small-circle circle highligt"></div>
        <div v-else
             class="small-circle circle gray"></div>
        <div class="line"></div>
      </div>
    </div>
    <!-- 尾部圆圈 -->
    <div class="cell">
      <div class="title"></div>
      <div class="circle-view">
        <div class="line"></div>
        <div class="header-footer-circle"></div>
        <div class="line"
             style="visibility:hidden"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      selIndex: 0
    }
  },
  props: {
    questions: Array
  },
  watch: {
    questions(value) {
      // 创建一个新数组
      let tempList = []
      tempList.push({ title: '问题单', section: true, mask: 'question-header', id: 'top' })
      value.map(item => {
        tempList.push({ title: item.questionContent, section: false, id: item.id })
      })
      this.list = tempList
    }
  },
  created() {
  },
  methods: {
    cellDidClick(index) {
      if (index === this.selIndex) return
      this.selIndex = index
      let idString = `${this.list[index].id}`
      this.$emit('clickEvent', idString)
    },
    changeSelIndex(index){
      this.selIndex=index
    }
  },
}
</script>

<style lang="scss">
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
.quest-directory {
  height: 100%;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  margin: 0 25px;
  .cell {
    height: 50px;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    .title {
      flex: 1;
      font-size: 16px;
      text-align: right;
      margin-right: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .gray-title {
      color: #999;
    }
    .highligt-title {
      color: #5f9de8;
    }
    .circle-view {
      align-self: stretch;
      width: 18px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .circle {
        border-radius: 50%;
        margin: 2px 0;
      }
      .big-circle {
        width: 16px;
        height: 16px;
      }
      .small-circle {
        width: 12px;
        height: 12px;
      }
      .gray {
        background: #e5e5e5;
      }
      .highligt {
        background: #5f9de8;
      }
      .header-footer-circle {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin: 2px 0;
        border: 2px solid #e5e5e5;
      }
      .line {
        flex: 1;
        background: #e5e5e5;
        width: 2px;
      }
    }
  }
}
</style>
